'use strict';

const Backbone = require('backbone');

module.exports = class ImportRequestModel extends Backbone.Model{
    getState() {
        return this.get('state');
    }

    isExtracted() {
        return this.getState() == 'extracted';
    }
};



// WEBPACK FOOTER //
// ./process/domain/entity/action/import-request.js